import { render, staticRenderFns } from "./motivos-evento-list.vue?vue&type=template&id=9ab5c2d6"
import script from "./motivos-evento-list.vue?vue&type=script&lang=js"
export * from "./motivos-evento-list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports